import React from 'react'
import { useHistory } from 'react-router-dom'
import { useToaster } from 'utils/useToaster'
import {
  useEvents,
  SortDirectionEnum,
  useAuth,
  UserPermissions,
  addEventInvoice,
} from '@modmd/data'
import { EventSessionDataList } from 'sharedComponents/EventSessionDataList'
import Datalist from 'components/Datalist'
import { ROUTES } from 'internal-portal/constants/routes'
import { Box } from 'components/Layout'
import { Switch } from 'components/Switch'
import Button from 'components/Button'
import { checkLaunchPopupError, launchPopup } from 'utils/helpers'

type FilterType = {
  companyId?: string
  groupId?: string
}

interface Props {
  filter: FilterType
  isClickable?: boolean
  containInvoiceBtn?: boolean
}

export const CompanyEvents: React.VFC<Props> = ({
  filter,
  isClickable = false,
  containInvoiceBtn = false,
}) => {
  const history = useHistory()
  const { hasPermission } = useAuth()
  const [testSessionsPage, setTestSessionsPage] = React.useState(1)
  const [canTableClick, setCanTableClick] = React.useState(false)
  const [qboLoading, setQboLoading] = React.useState(false)
  const [listOfInvoices, setListOfInvoices] = React.useState<Array<string>>([])
  const { setToastMessage } = useToaster()
  const [createInvoice] = addEventInvoice()

  const { data: eventsData, loading: isEventsLoading, refetch } = useEvents({
    filter: {
      ...filter,
    },
    page: Number(testSessionsPage) || 1,
    pageLength: 10,
    direction: SortDirectionEnum.DESC,
  })

  const handleCreateInvoice = React.useCallback(
    async (listOfInvoices) => {
      setQboLoading(true)
      try {
        const invoice = await createInvoice({
          variables: {
            inputData: listOfInvoices,
          },
        })
        setQboLoading(false)
        setToastMessage(`Invoice ${invoice.data?.addEventInvoice || ''} created`, 'success')

        setListOfInvoices([])
        void refetch()
      } catch (e) {
        setQboLoading(false)
        if (checkLaunchPopupError(String(e).split('Error: ')[1])) {
          launchPopup(String(e).split('Error: ')[1])
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setToastMessage]
  )

  return (
    <EventSessionDataList
      tableHeader={
        <Datalist.Title>
          Events
          {containInvoiceBtn && (
            <Box display="flex" alignItems="center">
              {hasPermission([UserPermissions.CREATE_INVOICE]) && (
                <Box display="flex" flexDirection="row">
                  <Switch
                    size="small"
                    isChecked={canTableClick}
                    onChange={() => setCanTableClick(!canTableClick)}
                    pr="1rem"
                  />
                  <Button
                    isFetching={qboLoading}
                    disabled={!(canTableClick && listOfInvoices.length && !qboLoading)}
                    size="small"
                    onClick={() => handleCreateInvoice(listOfInvoices)}
                  >
                    Create Invoice
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </Datalist.Title>
      }
      events={eventsData?.events?.events || []}
      pagination={eventsData?.events?.pagination}
      isLoading={isEventsLoading}
      hasPaginationInFooter
      onPageChange={setTestSessionsPage}
      onRowClick={
        isClickable ? ({ id }) => history.push(`/${ROUTES.EVENTS}/${String(id)}`) : undefined
      }
      listOfInvoices={listOfInvoices}
      setListOfInvoices={setListOfInvoices}
      eventRefetch={refetch}
      containInvoiceGenerator={canTableClick && containInvoiceBtn}
    />
  )
}
